export default String.raw`
<dialog class="dialog history-popup history-popup-js middle">
	<div class="dialog__header">
		<h2 class="dialog__header-title">{{translations.PurchaseHistory}}</h2>
		<form method="dialog">
			<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
	</div>
	<div class="dialog__content">
		{% assign sixMonths = "180.00:00:00" | ToTimeSpan -%}
		{% assign today = config.Now | Date: dateFormat -%}
		{% assign sixMonthsLater = config.Now | Plus: sixMonths | Date: dateFormat -%}

		<p class="history-popup__date">{{today}} - {{sixMonthsLater}}</p>
		<p class="history-popup__no-purchase no-purchase-history-js">{{translations.SixMonthsNoPurchase}}<br>({{today}} - {{sixMonthsLater}}).</p>
		
		<table class="table history-popup__table history-popup-table-js">
			<colgroup>
				<col style="width:175px">
				<col style="width:175px">
				<col style="width:175px">
				<col style="width:175px">
			</colgroup>
			<thead class="table__header">
				<tr class="table__row">
					<th class="table__cell">{{translations.DocumentNo}}</th>
					<th class="table__cell">{{translations.BuyDate}}</th>
					<th class="table__cell">{{translations.Price}}</th>
					<th class="table__cell">{{translations.Quantity}}</th>
				</tr>
			</thead>
			<tbody class="table__body history-popup-table-content-js"></tbody>
		</table>
	</div>
</dialog>
`